import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import landing page specific translation files
import enLandingTranslation from "./locales/landing/en.json";
import heLandingTranslation from "./locales/landing/he.json";

import type { Language, Direction, LanguageConfig } from "@/types/sites";

export interface LandingPageLanguage extends LanguageConfig {
  code: Language;
  name: string;
  nativeName: string;
  flag: string;
  direction: Direction;
}

export const landingPageSupportedLanguages: LandingPageLanguage[] = [
  {
    code: "en" as Language,
    name: "English",
    nativeName: "English",
    flag: "🇺🇸",
    direction: "ltr" as Direction,
  },
  {
    code: "he" as Language,
    name: "Hebrew",
    nativeName: "עברית",
    flag: "🇮🇱",
    direction: "rtl" as Direction,
  },
  {
    code: "es" as Language,
    name: "Spanish",
    nativeName: "Español",
    flag: "🇪🇸",
    direction: "ltr" as Direction,
  },
  {
    code: "fr" as Language,
    name: "French",
    nativeName: "Français",
    flag: "🇫🇷",
    direction: "ltr" as Direction,
  },
  {
    code: "de" as Language,
    name: "German",
    nativeName: "Deutsch",
    flag: "🇩🇪",
    direction: "ltr" as Direction,
  },
  {
    code: "it" as Language,
    name: "Italian",
    nativeName: "Italiano",
    flag: "🇮🇹",
    direction: "ltr" as Direction,
  },
  {
    code: "pt" as Language,
    name: "Portuguese",
    nativeName: "Português",
    flag: "🇵🇹",
    direction: "ltr" as Direction,
  },
  {
    code: "ru" as Language,
    name: "Russian",
    nativeName: "Русский",
    flag: "🇷🇺",
    direction: "ltr" as Direction,
  },
  {
    code: "ja" as Language,
    name: "Japanese",
    nativeName: "日本語",
    flag: "🇯🇵",
    direction: "ltr" as Direction,
  },
  {
    code: "ko" as Language,
    name: "Korean",
    nativeName: "한국어",
    flag: "🇰🇷",
    direction: "ltr" as Direction,
  },
  {
    code: "zh" as Language,
    name: "Chinese",
    nativeName: "中文",
    flag: "🇨🇳",
    direction: "ltr" as Direction,
  },
  {
    code: "ar" as Language,
    name: "Arabic",
    nativeName: "العربية",
    flag: "🇸🇦",
    direction: "rtl" as Direction,
  },
];

const landingPageResources = {
  en: {
    translation: enLandingTranslation,
  },
  he: {
    translation: heLandingTranslation,
  },
  es: {
    translation: enLandingTranslation,
  },
  fr: {
    translation: enLandingTranslation,
  },
  de: {
    translation: enLandingTranslation,
  },
  it: {
    translation: enLandingTranslation,
  },
  pt: {
    translation: enLandingTranslation,
  },
  ru: {
    translation: enLandingTranslation,
  },
  ja: {
    translation: enLandingTranslation,
  },
  ko: {
    translation: enLandingTranslation,
  },
  zh: {
    translation: enLandingTranslation,
  },
  ar: {
    translation: enLandingTranslation,
  },
};

// Create a separate i18n instance for the landing page
const landingPageI18n = i18n.createInstance();

landingPageI18n.use(initReactI18next).init({
  resources: landingPageResources,
  lng: "en", // default language
  fallbackLng: "en",
  debug: false,

  // Load translations synchronously to avoid delay
  initImmediate: false,

  interpolation: {
    escapeValue: false, // React already escapes values
  },

  // Don't use browser language detection for landing page
  // We want to control this manually
  detection: {
    order: [], // Empty array disables automatic detection
  },
});

export default landingPageI18n;
